import { makeCommsPage } from './commsPage'
import { CommsSearchView } from '../components/views/commsSearchView'

export default makeCommsPage({
    title: 'Search',
    intro: 'Find everything about a client or claim across every mailbox: the client record, the letters we sent and every conversation that came back.',
    probeUrl: 'comms/mailboxes/list',
    View: CommsSearchView,
    className: 'commsSearch',
})
